module.exports = __webpack_public_path__ + "img/denmark.223faa56.svg";